export default function() {
  const widgetName = 'photoGallery';
  const widgetOpts = photoGalleryOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $.fn.chunk = function(size) {
        var items = [];
        for (var i = 0; i < this.length; i += size) {
          items.push(this.slice(i, i + size));
        }
        return this.pushStack(items, "chunk", size);
      }
      
      $(`#${widgetName} .card-widget-item`).chunk(3).wrap('<div class="group"></div>');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 9,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false,
    textOverImage: false
  });

}